import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Project } from 'src/app/models';
import { ProjectsService } from 'src/app/services/projects.service';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styles: [``],
})
export class ProjectsComponent implements OnInit {
  public filterValue$: Observable<string>;
  public gridData$: Observable<GridDataResult>;
  public loaded$: Observable<boolean>;
  public pageSize = 40;
  public rowHeight = 30;
  public skip$ = new BehaviorSubject<number>(0);
  public sort$ = new BehaviorSubject<SortDescriptor[]>([
    {
      field: 'partNumber',
      dir: 'asc',
    },
  ]);
  constructor(public dialog: MatDialog, private projectsService: ProjectsService) {}

  ngOnInit() {
    this.loaded$ = this.projectsService.loaded$;
    this.filterValue$ = this.projectsService.filter$;

    this.gridData$ = combineLatest(this.projectsService.filteredEntities$, this.sort$, this.skip$).pipe(
      map(([projects, [sort], skip]) => {
        const data = sort.dir === 'asc' ? _.sortBy(projects, sort.field) : _.sortBy(projects, sort.field).reverse();

        const pagedData = data.slice(skip, skip + this.pageSize);
        return { data: pagedData, total: data.length };
      }),
    );
  }

  openNewDialog() {
    this.projectsService.openNewDialog().subscribe();
  }
  openEditDialog(project: Project) {
    this.projectsService.openEditDialog(project).subscribe();
  }

  delete(project: Project) {
    this.projectsService.delete(project);
  }
  filterProjects(filter) {
    this.projectsService.setFilter(filter);
  }
  public sortChange(sort: SortDescriptor[]) {
    this.sort$.next(sort);
  }

  public pageChange(event: PageChangeEvent) {
    this.skip$.next(event.skip);
  }
}
